import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the unlinkProjectSlice
const initialState = {
  loading: false,
  success: false,
  errorMessage: "",
  error: false
};

// Create the unlinkProjectSlice using createSlice
const unlinkProjectSlice = createSlice({
  name: "unlinkProject", // Slice name
  initialState, // Initial state
  reducers: {
    unlinkProject(state, action) {
      state.loading = true;
      state.success = false;
      state.errorMessage = "";
      state.error = false;
    },
    unlinkProjectSuccess(state, action) {
      state.loading = false;
      state.success = true;
      state.errorMessage = "";
      state.error = false;
    },
    unlinkProjectFailure(state, action) {
      state.loading = false;
      state.success = false;
      state.errorMessage = action.payload ?? "something went wrong";
      state.error = true;
    },
    resetUnlinkProject(state,action){
        state.loading = false;
        state.success = false;
        state.errorMessage = "";
        state.error = false;
    }
  },
});

// Export the reducer functions as actions
export const {
  unlinkProject,
  unlinkProjectSuccess,
  unlinkProjectFailure,
  resetUnlinkProject
} = unlinkProjectSlice.actions;
// Export the reducer function itself
export default unlinkProjectSlice.reducer;
